import * as React from "react";
import { Select, SelectItem } from "framework/controls/select";
import { getEntityField } from "framework/state/setfield";
import { useEventsPlanningOfficialsItemEdit } from "./itemStore";
import { cls_item_width } from "./view.css";
import { getOfficialLicenseStringByRole } from "public_app/officials/entity";
import { useEventPlanning_Actions, useEventPlanning_Officials_AllOfficialsList } from "../store";
export var OfficialRoleSelector = function (props) {
    var _a;
    var _b = useEventsPlanningOfficialsItemEdit(), state = _b[0], actions = _b[1];
    var _c = useEventPlanning_Officials_AllOfficialsList(), allOfficials = _c[0], officials_actions = _c[1];
    var event_actions = useEventPlanning_Actions();
    var toString = function (err) {
        return err != null ? Array.isArray(err) ? err.join(", ") : err.toString() : null;
    };
    var officialGlobalErrors = toString((_a = state.errors['eventCompetitions[0].officials']) === null || _a === void 0 ? void 0 : _a.errors);
    React.useEffect(function () {
        actions.setAvailableOfficialRoles(officials_actions.officials_getAvailableOfficialRoles(state.entity.idt));
    }, [state.entity.idt, allOfficials.collection]);
    React.useEffect(function () {
        if (state.entity.id) {
            actions.saveOfficial(false);
            officials_actions.officials_setRoleOfOfficial(state.entity.id, state.entity.role);
        }
    }, [state.entity.role]);
    var getter = function (field) {
        var value = getEntityField(state, field);
        return value === null || value === void 0 ? void 0 : value.toString();
    };
    var setter = function (field, value, validator, storeInvalidValue) {
        var value2 = value ? Number(value) : "";
        event_actions.event_cancelCheck();
        return actions.setEntityField(field, value2, validator, storeInvalidValue);
    };
    var officialForLicense = allOfficials.collection.find(function (o) { return o.id == state.entity.idt; });
    function onlyRole(val) {
        var role = state.availableOfficialRoles.find(function (r) { return r.key == val; });
        if (role !== undefined) {
            return role.value;
        }
        return "";
    }
    return React.createElement(Select, { name: "role", state: state, getter: getter, setter: setter, contentClassName: cls_item_width, keyToTextMapFunc: onlyRole, disabled: props.disabled, error: officialGlobalErrors }, state.availableOfficialRoles.map(function (r) { return React.createElement(SelectItem, { key: r.key, value: r.key.toString(), children: r.value + ", " + getOfficialLicenseStringByRole(officialForLicense, r.key) }); }));
};
